import type {LucideIcon} from 'lucide-react';

interface MetricProps {
  icon: LucideIcon;
  value: string;
  label: string;
}

export function Metric({icon: Icon, value, label}: MetricProps) {
  return (
    <div className='min-w-0 max-[660px]:flex max-[660px]:flex-col'>
      <div className='flex min-w-0 items-center gap-1.5'>
        <Icon className='w-5 h-5 text-gray-400 shrink-0' />
        <p className='min-w-0 whitespace-nowrap text-xl font-bold leading-tight max-[660px]:text-lg'>
          {value}
        </p>
      </div>
      <p className='text-xs mt-1 text-gray-500 '>{label}</p>
    </div>
  );
}
